import { useRef } from 'react';
import CSPortfolioComponent from './cs/CSPortfolioComponent';
import CSHeroSection, { FIELD_RGB } from './cs/CSHeroSection';
import { projects, sections } from './cs/csProjects';

export default function CSPortfolio() {
  // The run's own jump-to-category, handed back by the component below: where a category
  // begins is measured off the cards, so only that component can know it. The landing's
  // heading drives it through here.
  const scrollToSection = useRef(null);

  return (
    <div className="min-h-screen bg-black text-pink-500 flex flex-col items-center relative">
      <div
          className="absolute inset-0 pointer-events-none opacity-20 mb-20"
          style={{
            backgroundImage: `
              linear-gradient(rgba(255, 255, 255) 1px, transparent 1px),
              linear-gradient(90deg, rgba(255, 255, 255) 1px, transparent 1px)
            `,
            backgroundSize: "20px 20px",
          }}
        />
         <div
           className="absolute inset-0 pointer-events-none"
           style={{
             background: `
               linear-gradient(to bottom,
                 rgba(0, 0, 0, 0.5) 0%,
                 rgba(0, 0, 0, 0.8) 30%,
                 rgba(0, 0, 0, 0.9) 60%,
                 rgba(0, 0, 0, 1) 100%
               )
             `,
           }}
         />
          {/* Above the grid and the fade, which are laid over the whole page: the landing
              is a photo on its own flat field and neither belongs on it. data-header-fill
              hands the header that yellow while it is crossing this section — see
              page_assets/header. */}
          <div className="relative z-10 w-full" data-header-fill={FIELD_RGB}>
            <CSHeroSection
              // The landing's heading is the page's other section nav. `id` is the index
              // into this list, which is what the run's own jump takes — the heading and
              // the wheel end up on the same call.
              sections={sections.map((section, index) => ({ id: index, label: section.name }))}
              onSelectSection={(index) => scrollToSection.current?.(index)}
            />
          </div>

          <div className="relative z-10 w-full flex flex-col items-center mb-20">
            <CSPortfolioComponent
              projects={projects}
              sections={sections}
              accent="yellow"
              scrollToRef={scrollToSection}
            />
          </div>
    </div>
  );
}
